export const GET_PROGRAM_LEVELS = "GET_PROGRAM_LEVELS";
export const GET_PROGRAM_LEVEL_BY_ID = "GET_PROGRAM_LEVEL_BY_ID";
export const UPDATE_PROGRAM_LEVEL = "UPDATE_PROGRAM_LEVEL";
export const DELETE_PROGRAM_LEVEL = "DELETE_PROGRAM_LEVEL";
export const CREATE_PROGRAM_LEVEL = "CREATE_PROGRAM_LEVEL";
